import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PortalEventContextType, useGetAuthenticatedPortalSourcingEventsQuery } from "../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

const DISPLAY_LIMIT = 6;

export const InvitationsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDate = useDisplayDate();

  const { data, isLoading, isError } = useGetAuthenticatedPortalSourcingEventsQuery({
    context: PortalEventContextType.Private,
    limit: DISPLAY_LIMIT,
  });
  const events = data?.events ?? [];

  return (
    <HomePanel
      titleKey="Invitations"
      seeAllTo={urls.v2.supplier.procurements}
      isLoading={isLoading}
      isError={isError}
      isEmpty={events.length === 0}
      emptyKey="No invitations right now"
    >
      <PanelTable headers={[t("Title"), t("Buyer"), t("Deadline")]}>
        {events.map((event) => (
          <PanelRow key={event.id} onClick={() => navigate(urls.v2.supplier.procurement.go(event.id))}>
            <TitleCell title={event.title || t("Untitled")} />
            <MutedCell>{event.buyerName}</MutedCell>
            <MutedCell>
              {event.bidSubmissionDeadline ? displayDate(event.bidSubmissionDeadline) : "—"}
            </MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
